import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                mt: 6,
                borderTop: "1px solid rgba(148, 163, 184, 0.16)",
                bgcolor: "#ffffff",
            }}
        >
            <Container maxWidth="xl">
                <Box
                    sx={{
                        minHeight: 56,
                        py: 1.2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        flexWrap: "wrap",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: "0.82rem",
                            color: "#64748b",
                            lineHeight: 1.5,
                        }}
                    >
                        © {new Date().getFullYear()} Qarzhy.kz. Все права защищены.
                    </Typography>

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2.5,
                            flexWrap: "wrap",
                        }}
                    >
                        <Button
                            component={Link}
                            to="/privacy"
                            color="inherit"
                            sx={{
                                minWidth: "auto",
                                p: 0,
                                fontSize: "0.82rem",
                                fontWeight: 600,
                                color: "#64748b",
                                textTransform: "none",
                                "&:hover": {
                                    backgroundColor: "transparent",
                                    color: "#0f172a",
                                },
                            }}
                        >
                            Политика конфиденциальности
                        </Button>

                        <Button
                            component={Link}
                            to="/terms"
                            color="inherit"
                            sx={{
                                minWidth: "auto",
                                p: 0,
                                fontSize: "0.82rem",
                                fontWeight: 600,
                                color: "#64748b",
                                textTransform: "none",
                                "&:hover": {
                                    backgroundColor: "transparent",
                                    color: "#0f172a",
                                },
                            }}
                        >
                            Пользовательское соглашение
                        </Button>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;